// extracted by mini-css-extract-plugin
module.exports = {"widget":"dashboard_widget__2xNdh","button":"dashboard_button__1vnEs","list":"dashboard_list__2a7cA","ellipse":"dashboard_ellipse__3lg9-","status":"dashboard_status__1HKaj"};